import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { orquestraApiRef, OrquestraImagineDetailClient } from './api';

export const orquestraPlugin = createPlugin({
  id: 'orquestra',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: orquestraApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new OrquestraImagineDetailClient(discoveryApi, fetchApi, identityApi),
    }),
  ],
});

export const OrquestraPage = orquestraPlugin.provide(
  createRoutableExtension({
    name: 'OrquestraPage',
    component: () =>
      import('./components/OrquestraRouter').then(m => m.OrquestraRouter),
    mountPoint: rootRouteRef,
  }),
);
